import Vue from 'vue';
import { mapGetters } from 'vuex';
import { importSite } from '@storm/mixins/import-site';

export default Vue.component('import-site', {
  template: require('./template.html'),
  name: 'import-site',
  computed: {
    ...mapGetters(['account', 'currentUser', 'identityId']),
  },
  mixins: [importSite],
  props: ['modal', 'current-site', 'toggle-modal'],
  data() {
    return {
      loading: false,
      importErrors: [],
    };
  },
  watch: {
    modal(o) {
      if (o) {
        this.resetModal();
      }
    },
  },
  methods: {
    resetModal() {
      this.loading = false;
      this.importErrors = [];
    },
    closeModal(type) {
      this.$emit('toggle-modal', type, 'child');
    },
    formatErrors(ers) {
      return ers.join(' ');
    },
  },
});



// WEBPACK FOOTER //
// ./src/storm/import-site/index.js